// Customers subpage carousel

require('slick-carousel')

$(() => {
  const $body = $(document.body)

  if ($body.hasClass('page--customers-inner')) {
    // Initialize Slick
    const $carousel = $('.js_team-carousel').slick({
      arrows: true,
      autoplay: true,
      draggable: false,
      fade: true,
      mobileFirst: true,
    })

    // Slide Controls
    $('.js_team-arrow-left').click(() => $carousel.slick('slickPrev'))

    $('.js_team-arrow-right').click(() => $carousel.slick('slickNext'))
  }
})
